/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDualScreen = createReactComponent("dual-screen", "IconDualScreen", [
  ["path", { d: "M5 4l8 3v15l-8 -3z", key: "svg-0" }],
  ["path", { d: "M13 19h6v-15h-14", key: "svg-1" }]
]);

export { IconDualScreen as default };
//# sourceMappingURL=IconDualScreen.js.map
